module.exports = __webpack_public_path__ + "static/media/rtvc.935722c4.png";